export default "__VITE_ASSET__Dcu1gX8w__"